export default __webpack_public_path__ + "ede5f97d1b123671b665918d76764c81.png";